import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { format } from "date-fns";

import UploadingStatus from "features/medical-scribe/components/uploading-status.component";
import FieldLabel from "features/staff-tasks-v2/drawer/staff-task-card/field-label.component";

type EditScribeMetadataHeaderProps = {
  createdAt: string | undefined;
  status: number | undefined;
  appointmentTypeLabel: string;
  scribeTemplateLabel: string;
  addToChartNotes: boolean;
  isPaused: boolean;
  onAddToChartNotesChange: (value: boolean) => void;
};

export default function EditScribeMetadataHeader({
  createdAt,
  status,
  appointmentTypeLabel,
  scribeTemplateLabel,
  addToChartNotes,
  isPaused,
  onAddToChartNotesChange
}: Readonly<EditScribeMetadataHeaderProps>) {
  return (
    <Stack
      direction="row"
      flexWrap="wrap"
      columnGap={5}
      rowGap={2}
      sx={{ pt: 2, pb: 1 }}
    >
      <Stack rowGap={1}>
        <FieldLabel label="Created" sx={{ mb: "3px" }} />
        <Typography fontSize="16px" lineHeight="18px">
          {createdAt
            ? format(new Date(createdAt), "MM/dd/yyyy hh:mm aaa")
            : "—"}
        </Typography>
      </Stack>

      <Stack rowGap={1}>
        <FieldLabel label="Status" sx={{ mb: "3px" }} />
        <UploadingStatus status={status} />
      </Stack>

      <Stack rowGap={1}>
        <FieldLabel label="Appointment Type" sx={{ mb: "3px" }} />
        <Typography fontSize="16px" lineHeight="18px">
          {appointmentTypeLabel}
        </Typography>
      </Stack>

      <Stack rowGap={1}>
        <FieldLabel label="Scribe Template" sx={{ mb: "3px" }} />
        <Typography fontSize="16px" lineHeight="18px">
          {scribeTemplateLabel}
        </Typography>
      </Stack>

      {/* <Stack rowGap={0.5}>
        <FieldLabel label="Add to Chart Note" sx={{ mb: "3px" }} />
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Switch
            checked={addToChartNotes}
            disabled={!isPaused}
            onChange={(_, checked) => onAddToChartNotesChange(checked)}
            color="primary"
            size="small"
          />
          <Typography fontSize="16px" lineHeight="18px">
            {addToChartNotes ? "Yes" : "No"}
          </Typography>
        </Stack>
      </Stack> */}
    </Stack>
  );
}
